"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseStyles = void 0;
var theme_1 = require("../../../theme");
exports.baseStyles = "\n    [id] {\n        scroll-margin-top: calc(" + theme_1.theme.lineHeights[0] + " * 2);\n    }\n";
